import React from "react";
import { Wrapper, Container } from "./styles";

const ModalStickyFooter = ({
  children,
  styles,
  dStyles
}: {
  children: any;
  styles?: any;
  dStyles?: any;
}) => {
  return (
    <Wrapper>
      <Container styles={styles} dStyles={dStyles}>
        {children}
      </Container>
    </Wrapper>
  );
};

export default ModalStickyFooter;
